import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { replayQueuedRequests } from "../offline/fetchProxy";

export default function QueueAuthGate() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onAuthRequired = () => {
      // Navigate to login, preserving return URL
      navigate("/login", { state: { from: location.pathname } });
    };
    window.addEventListener("vela:queue-auth-required", onAuthRequired);
    return () =>
      window.removeEventListener("vela:queue-auth-required", onAuthRequired);
  }, [navigate, location.pathname]);

  useEffect(() => {
    const onLogin = () => {
      // After login, replay queued requests
      replayQueuedRequests();
    };
    window.addEventListener("vela:logged-in", onLogin);
    return () => window.removeEventListener("vela:logged-in", onLogin);
  }, []);

  return null;
}
